import { FormInputProps } from 'brief-form'

import { SingleSelectAutoSuggestOpts } from '../SingleSelectAutoSuggest'

export type BankUserSelectOpts = Omit<SingleSelectAutoSuggestOpts, 'listName' | 'options'> & {
  filters?: { field: string; type: string; value: string | number }[]
}

export interface BankUserSelectProps extends FormInputProps<number | string, BankUserSelectOpts> {}
